import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { DocumentRule, IDocumentRule } from "@/models/document-rule.entity";

export const DocumentRuleDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IDocumentRule, ""> {
  getIdentifier(entity: IDocumentRule): string {
    return (entity as IDocumentRule).id;
  }

  mapEntity(entity: IDocumentRule): IDocumentRule {
    return new DocumentRule(entity);
  }
})();
